export enum CollaborationDataType {
  // avoiding 0 to prevent confusion with falsy values
  sortableInput = 1,
  sortableTimerStart = 2,
  formElementPartial = 3,
  aiAgentResponse = 4,
  interactiveFormSuggestions = 5,
  previewExperienceActiveSlide = 6,
  interactiveForm = 7,
  aiAgentRequest = 8,
}
